import script from "./CSmallCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSmallCard.vue?vue&type=script&setup=true&lang=ts"

import "./CSmallCard.vue?vue&type=style&index=0&id=2a5bdd17&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_ejoqcbfru5qt7peog562lsj5cy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a5bdd17"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/.pnpm/vue-cli-plugin-quasar@4.0.4/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
